import { Box, Center, Divider, Heading, HStack } from "@chakra-ui/react";
import React from "react";
import { Image } from '@chakra-ui/react'

export const Logo = () => {
  return (
    <HStack>
      <Box boxSize={50} borderRadius="full">
      <Image
    boxSize='50px'
    src='https://aarya.network/images/logo.png'
    alt='Project Aarya'
  />
      </Box>

      <Heading
        size="md"
        fontWeight={900}
        bgGradient={"linear(to-r, #eb692d, #e0865c)"}
        bgClip="text"
      >
        Aarya
      </Heading>
    </HStack>
  );
};
